<div *ngIf="submitted==true">
  <div class="overlay"></div>
  <div class="main">
    <img id="stay-tuned" src="../../assets/stay-tuned(2).png">
    <div class="stay-tuned">
      <p class="message" style="font-size: 20px; font-weight: 600;">Stay Tuned</p>
      <p class="message" style="font-size: 14px;">Form Submitted Successfully</p>
      <div class="social_media_links">
        <a href="https://twitter.com/amityincubator" target="_blank" rel="noopener noreferrer">
          <img class="link-icons" src="../../assets/Twitter.png" alt="">
        </a><a href="https://www.linkedin.com/company/amityincubator" target="_blank" rel="noopener noreferrer">
          <img class="link-icons" src="../../assets/Linkedin.png" alt="">
        </a><a href="https://www.facebook.com/amityincubator" target="_blank" rel="noopener noreferrer">
          <img class="link-icons" src="../../assets/Facebook.png" alt="">
        </a><a href="https://www.youtube.com/channel/UCrVG4nXc5uitLQSqChVrKEQ" target="_blank"
          rel="noopener noreferrer">
          <img class="link-icons" src="../../assets/Youtube.png" alt="">
        </a>
      </div>
    </div>
  </div>
</div>

<div *ngIf="error==true">
  <div class="overlay"></div>
  <div class="main">
    <img id="used-email" src="../../assets/used-email.gif" style="border-radius: 10px;">
  </div>
</div>


<div class="bg-div">
  <!-- side bar -->
  <div class="side-menu">
    <img src="../../assets/SVG/Artboard 1.svg" class="image-styling dsk" alt="" />
    <div class="side-bar-icon-container-up side-menu-div">
      <span (click)="previous()" class="material-icons side-icon">arrow_circle_up</span>
    </div>
    <div class="center-dots side-menu-div">
      <div class="mb logo">
        <!-- <img src="../../assets/Incubator.png" alt="AII" class="mb-aii-logo"> -->
        <app-arvr-logo></app-arvr-logo>
      </div>
      <div style="flex: 1"></div>
      <div class="mb-dots dot-cont" id="dot-con">
        <div class="circle" id="one"></div>
        <div class="circle" id="spacer" style="background-color: transparent"></div>
        <div class="circle" id="two"></div>
      </div>
      <div style="flex: 1"></div>
    </div>
    <div class="side-bar-icon-container-down side-menu-div">
      <span (click)="next()" class="material-icons side-icon">arrow_circle_down</span>
    </div>
  </div>
  <!-- form -->
  <div class="form-div">
    <!-- <img src="../../assets/Incubator.svg" alt="AII" class="aii-logo dsk"> -->
    <app-arvr-logo class="aii-meta-logo dsk" style="margin-bottom: 5%;"></app-arvr-logo>
    <br><br><br>
    <h1 *ngIf="activeSection == 1" class="heading">Contact Details</h1>
    <h1 *ngIf="activeSection == 2" class="heading">About Startup</h1>

    <form [formGroup]="startupData" (ngSubmit)="submit()">
      <!-- section one -->
      <div *ngIf="activeSection == 1" class="form-margin">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6">
              <mat-form-field class="full-width form-area">
                <label class="input-label req">FIRST NAME</label>
                <input matInput formControlName="sFname" />
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field class="full-width form-area">
                <label class="input-label req">LAST NAME</label>
                <input matInput formControlName="sLname" />
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <mat-form-field class="full-width form-area">
                <label class="input-label req">EMAIL</label>
                <input matInput formControlName="sEmail" type="email" />
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field class="full-width form-area">
                <label class="input-label req">MOBILE</label>
                <input matInput formControlName="sMobile" type="tel" />
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <mat-form-field class="full-width form-area">
                <label class="input-label req">UNIVERSITY</label>
                <input matInput formControlName="sUniversity" type="tel" />
                <!-- <mat-select formControlName="sUniversity" (selectionChange)="sUniversityChange()">
                  <mat-option *ngFor="let e of university" [value]="e">{{ e.Uni_Name }}
                  </mat-option>
                </mat-select> -->
              </mat-form-field>
              <div *ngIf="sUniversityCheck">
                <mat-form-field [style.width.%]=100>
                  <mat-label class="input-label req">Other</mat-label>
                  <input matInput formControlName="sUniversityInput">
                </mat-form-field>

              </div>
            </div>
            <div class="col-md-6">
              <mat-form-field class="full-width form-area">
                <label class="input-label req">INSTITUTE</label>
                <!-- <mat-select formControlName="sInstitute" (selectionChange)="sInstituteChange()">
                  <mat-option *ngFor="let e of institute" [value]="e">{{ e.Institute_Name }}
                  </mat-option>
                </mat-select> -->
                <input matInput formControlName="sInstitute" type="tel" />
              </mat-form-field>
              <div *ngIf="sInstituteCheck">
                <mat-form-field [style.width.%]=100>
                  <mat-label class="input-label req">Other</mat-label>
                  <input matInput formControlName="sInstituteInput">
                </mat-form-field>

              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <mat-form-field class="full-width form-area">
                <label class="input-label req">PROGRAM</label>
                <!-- <mat-select formControlName="sProgram" (selectionChange)="sProgramChange()">
                  <mat-option *ngFor="let e of program" [value]="e">{{ e.Program_Name }}
                  </mat-option>
                </mat-select> -->
                <input matInput formControlName="sProgram">
              </mat-form-field>
              <div *ngIf="sProgramCheck">
                <mat-form-field [style.width.%]=100>
                  <mat-label class="input-label req">Other</mat-label>
                  <input matInput formControlName="sProgramInput" style="padding-right: 5%;">
                </mat-form-field>

              </div>
            </div>

            <div class="col-md-6" style="margin-top:2%">

            </div>


          </div>

        </div>
      </div>

      <!-- section two -->
      <div *ngIf="activeSection == 2" class="form-margin">
        <div class="container-fluid">
          <div class="row row-custom-padding">
            <mat-form-field class="full-width form-area">
              <!-- <mat-label>Startup Name*</mat-label> -->
              <label class="input-label req">STARTUP NAME</label>
              <input matInput formControlName="sName" />
            </mat-form-field>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-area" style="
                  display: flex;
                  flex-direction: column;
                  margin-bottom: 0px;
                  height: 50%;
                ">
                <label class="input-label req" for="problemStatement">PROBLEM STATEMENT</label>
                <textarea [ngClass]="{ 'force-warn': problemStatementWarn }" id="problemStatement"
                  formControlName="sProblemStatement" maxlength="1200" #problemStatement
                  (keyup)="changeCharCount(problemStatement.value)"></textarea>
                <p style="text-align: right">{{ 1200 - textCount }}</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-area" style="
                  display: flex;
                  flex-direction: column;
                  margin-bottom: 0px;
                  height: 50%;
                ">
                <label class="input-label req" for="ideaPitch">IDEA PITCH</label>
                <textarea [ngClass]="{ 'force-warn': ideaPitchWarn }" id="ideaPitch" formControlName="sIdeaPitch"
                  maxlength="1200" #ideaPitch (keyup)="changeCharCount2(ideaPitch.value)"></textarea>
                <p style="text-align: right">{{ 1200 - textCount2 }}</p>
              </div>

            </div>
          </div>

          <div class="row">
            <div class="row-custom-padding" style="width: 100%">
              <!-- <label for="pitch">
                                      UPLOAD PITCH DECK:
                                      <img [src]="pitchBase64" alt="" style="width: 80px; margin-left: 24px;">
                                  </label> -->
              <label for="pitchinput" class="input-label" style="
                        display: flex;
                        flex-direction: column;
                        cursor: pointer;
                        width: 100%;
                        position: relative;
                      " (mouseenter)="mouseEnter('pitch')" (mouseleave)="mouseLeave('pitch')">
                <span style="margin-bottom: 0.5em">BPLAN:</span>
                <span class="tool-tip" id="pitch">Allowed Extensions pdf, pptx, ppt<br />Max File Size:
                  5MB</span>
                <!-- <label>PITCH DECK:</label> -->
                <div class="mb-dsk-flex">
                  <!-- <div style="width: 20%;"> -->
                  <img id="non-uploaded" [src]="pitchBase64" alt="" class="upload-img pitchPlace"
                    *ngIf="!pitchChanged" />
                  <img id="pdf" [src]="pitchBase64" alt="pdf" class="upload-img" *ngIf="pitchChanged"
                    style="width: 50px" />
                  <!-- </div> -->

                  <div>
                    <a href="http://bit.ly/2SZyZB1" rel="noopener noreferrer" class="pitch-deck-i" target="_blank">
                      <img src="../../assets/information-2.svg" alt="" style="width: 12px; height: 17px" />
                      <p style="
                                padding: 0;
                                font-size: 12px;
                                margin: 0;
                                margin-left: 6px;
                              ">
                        Wondering about what details to mention in the BPan!
                        Take a look at the <strong>
                          <u>BPlan Format.</u>
                        </strong>
                      </p>
                    </a>
                    <p *ngIf="
                              pitchBase64 == '../../assets/upload/Error_upload.svg'
                            " style="
                              font-size: 14px;
                              margin-left: 12px;
                              color: red;
                              font-weight: bold;
                              margin-top: 8px;
                            ">
                      Please upload a .pdf,.pptx,.ppt file only.
                    </p>
                  </div>
                </div>
              </label>
              <input type="file" id="pitchinput" #pitchinput (change)="pitchUpload(pitchinput.files)"
                accept=".pdf,.pptx,.ppt" style="display: none" />
            </div>
          </div>


          <!-- </div> -->
        </div>
      </div>



      <div class="actions" style="cursor: pointer" [ngClass]="{
          disabledCursor: !startupData.valid
        }">

        <button *ngIf="activeSection != 2" type="button" class="theme-btn" style="
            padding-left: 24px;
            padding-right: 15px;
            padding-top: 12px;
            padding-bottom: 10px;
          " (click)="next()">
          Continue
          <span style="vertical-align: middle" class="material-icons">
            keyboard_arrow_right
          </span>
        </button>

        <button *ngIf="activeSection == 2" type="submit" class="theme-btn" [ngClass]="{ disabledBtn:  
          !(startupData.valid)    
        }">
          <div class="sninner-cont" *ngIf="progressSpinner">
            <mat-spinner diameter="20"></mat-spinner>
          </div>
          <ng-container *ngIf="!progressSpinner"> Submit </ng-container>
        </button>
      </div>

      <div id="snack" class="msg" style="margin: auto; padding-top: 24px">
        {{ message }}
      </div>
    </form>
  </div>
</div>

<div>
  <div class="arrow_up">
    <button mat-fab color="#ea601a" (click)="show()" [ngStyle]="{ display: !showOptions ? 'block' : 'none' }" style="
        position: fixed;
        bottom: 20px;
        right: 40px;
        z-index: 1;
        transition: 0.8s;
      " class="global-mb">
      <img src="../../assets/support.png" alt="Contact Us" height="24px" width="24px"
        style="filter: hue-rotate(0deg)" />
    </button>
  </div>
  <div class="arrow_up">
    <button mat-fab color="#ea601a" (click)="show()" [ngStyle]="{ display: showOptions ? 'block' : 'none' }" style="
        position: fixed;
        bottom: 20px;
        right: 40px;
        z-index: 1;
        transition: 0.8s;
      " class="global-mb">
      <mat-icon style="color: #ea601a">keyboard_arrow_down</mat-icon>
    </button>
  </div>
  <div class="call" [ngStyle]="{ display: showOptions ? 'block' : 'none' }">
    <button mat-fab color="#fff" style="
        position: fixed;
        bottom: 80px;
        right: 40px;
        z-index: 1;
        transition: 0.8s;
      " class="global-mb">
      <a href="tel:01204392243" target="_blank" rel="noopener noreferrer">
        <i style="color: #ea601a" class="fa fa-phone fa-lg" aria-hidden="true"></i>
      </a>
    </button>
    <button mat-fab color="#fff" style="
        position: fixed;
        bottom: 140px;
        right: 40px;
        z-index: 1;
        transition: 0.8s;
      " class="global-mb">
      <a href="mailto:info@aii.amity.edu" target="_blank" rel="noopener noreferrer">
        <i style="color: #ea601a" class="fa fa-envelope fa-lg" aria-hidden="true"></i>
      </a>
    </button>
    <button mat-fab color="#fff" style="
        position: fixed;
        bottom: 200px;
        right: 40px;
        z-index: 1;
        transition: 0.8s;
      " class="global-mb">
      <a href="https://wa.me/+9101204392243" target="_blank" rel="noopener noreferrer" style="color: #ea601a">
        <i class="fab fa-whatsapp fa-lg" style="font-size: 25px" aria-hidden="true"></i>
      </a>
    </button>
  </div>
</div>